import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Tweens } from "../Components/Effects/Tweens";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { CustomEase } from "../Components/Effects/CustomEase";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../Utils/FrameTimer";
import { PlayList } from "../Components/Sounds/PlayList";
import { FreespinsView } from "../GameComponents/Freespins/FreespinsView";

@engineComponent(ComponentTypes.DisplayObject)
export class RandomElement extends SwitchElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    public view: FreespinsView;

    private created: boolean;

    // private min: number;

    // private max: number;

    private initialDelay: number;

    private finalDelay: number;

    private duration: number;

    private rectX: number;

    private rectY: number;

    private rectWidth: number;

    private rectHeight: number;

    private minScale: number;

    private maxScale: number;

    private minAlpha: number;

    private maxAlpha: number;

    private goToDelay: number;

    private goToDuration: number;

    private goToX: number;

    private goToXStep: number;

    private goToY: number;

    private goToYStep: number;

    private goToScale: number;

    private selectionTimer: FrameTimerEventEmitter;

    private selectionSymbols: Array<number>;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor() {
        super();

        this.view = null;
        this.created = false;
    }

    //******************************************************************************************************************
    //  CREATE
    //******************************************************************************************************************

    public createByNode(node: Element): void {
        super.createByNode(node);

        if (!this.created) {
            this.created = true;

            // this.min = Math.max((node.hasAttribute('Min')) ? parseInt(node.getAttribute('Min')) : 2, 1);
            // this.max = Math.max((node.hasAttribute('Max')) ? parseInt(node.getAttribute('Max')) : 4, this.min);
            this.initialDelay = node.hasAttribute("InitialDelay") ? parseInt(node.getAttribute("InitialDelay")) : 40;
            this.finalDelay = node.hasAttribute("FinalDelay") ? parseInt(node.getAttribute("FinalDelay")) : 180;
            this.duration = node.hasAttribute("Duration") ? parseInt(node.getAttribute("Duration")) : 120;
            this.rectX = node.hasAttribute("RectX") ? parseInt(node.getAttribute("RectX")) : 0;
            this.rectY = node.hasAttribute("RectY") ? parseInt(node.getAttribute("RectY")) : 0;
            this.rectWidth = node.hasAttribute("RectWidth") ? parseInt(node.getAttribute("RectWidth")) : 100;
            this.rectHeight = node.hasAttribute("RectHeight") ? parseInt(node.getAttribute("RectHeight")) : 100;
            this.minScale = node.hasAttribute("MinScale") ? parseFloat(node.getAttribute("MinScale")) : 0;
            this.maxScale = node.hasAttribute("MaxScale") ? parseFloat(node.getAttribute("MaxScale")) : 1;
            this.minAlpha = node.hasAttribute("MinAlpha") ? parseFloat(node.getAttribute("MinAlpha")) : 0;
            this.maxAlpha = node.hasAttribute("MaxAlpha") ? parseFloat(node.getAttribute("MaxAlpha")) : 1;
            this.goToDelay = node.hasAttribute("GoToDelay") ? parseInt(node.getAttribute("GoToDelay")) : 30;
            this.goToDuration = node.hasAttribute("GoToDuration") ? parseInt(node.getAttribute("GoToDuration")) : 150;
            this.goToX = node.hasAttribute("GoToX") ? parseInt(node.getAttribute("GoToX")) : 0;
            this.goToXStep = node.hasAttribute("GoToXStep") ? parseInt(node.getAttribute("GoToXStep")) : 0;
            this.goToY = node.hasAttribute("GoToY") ? parseInt(node.getAttribute("GoToY")) : 0;
            this.goToYStep = node.hasAttribute("GoToYStep") ? parseInt(node.getAttribute("GoToYStep")) : 0;
            this.goToScale = node.hasAttribute("GoToScale") ? parseFloat(node.getAttribute("GoToScale")) : 0;

            if (node.hasAttribute("EasingX")) {
                CustomEase.create("randomElementX", node.getAttribute("EasingX"));
            }

            if (node.hasAttribute("EasingY")) {
                CustomEase.create("randomElementY", node.getAttribute("EasingY"));
            }

            if (node.hasAttribute("EasingScale")) {
                CustomEase.create("randomElementScale", node.getAttribute("EasingScale"));
            }

            if (node.hasAttribute("EasingAlpha")) {
                CustomEase.create("randomElementAlpha", node.getAttribute("EasingAlpha"));
            }

            this.selectionTimer = CreateFrameTimer("selectionTimer");
            this.selectionTimer.on(FrameTimerEvents.Complete, this.onSelectionTimer.bind(this));
        }
    }

    //******************************************************************************************************************
    //  SELECT
    //******************************************************************************************************************

    /*public select(symbol: number): { delay: number; duration: number; } {
        this.selectionSymbol = symbol;

        const count = Math.round(Math.random() * (this.max - this.min) + this.min);
        const steps: Array<number> = [];

        steps.push(symbol);

        for (let i = 0; i < count - 1; i++) {
            let value = steps[0];

            while (value === steps[0]) {
                value = Math.round(Math.random() * (9 - 1) + 1);
            }

            steps.unshift(value)
        }

        this.tease(steps, 0);

        const time = this.initialDelay + (this.duration * (count - 0.5));

        return {delay: time, duration: time + this.finalDelay};
    }*/

    // public select(symbol: number): { delay: number; duration: number; } {
    public select(symbols: Array<number>): void {
        this.selectionSymbols = symbols;

        const steps = [1, 2, 3, 4, 5, 6, 7, 8, 9];

        for (let i = 0; i < this.selectionSymbols.length; i++) {
            steps.splice(steps.indexOf(this.selectionSymbols[i]), 1);
        }

        steps.sort(function (): number {
            return 0.5 - Math.random();
        });
        steps.push(this.selectionSymbols[this.selectionSymbols.length - 1]);

        this.tease(steps, 0);

        // const time = this.initialDelay + (this.duration * (9 - 0.5));

        // return {delay: time, duration: time + this.finalDelay};
    }

    //******************************************************************************************************************
    //  TEASE
    //******************************************************************************************************************

    private tease(steps: Array<number>, step: number): void {
        this.goToCase("SYMBOL_" + steps[step]);

        const delay = step === 0 ? this.initialDelay : 0;
        let duration = this.duration;

        if (steps.length === 1) {
            duration = 0;
        }

        Tweens.removeTweens(this, "all");
        Tweens.customTween(this, {
            tween: "position.x",
            tweenValues: [this.rectX + this.rectWidth, this.rectX],
            tweenDelay: [delay],
            tweenDuration: [duration],
            tweenEase: ["randomElementX"],
        });
        Tweens.customTween(this, {
            tween: "position.y",
            tweenValues: [this.rectY + this.rectHeight, this.rectY],
            tweenDelay: [delay],
            tweenDuration: [duration],
            tweenEase: ["randomElementY"],
        });
        Tweens.scaleTween(this, {
            tweenValues: [new PIXI.Point(this.minScale, this.minScale), new PIXI.Point(this.maxScale, this.maxScale)],
            tweenDelay: delay,
            tweenDuration: duration,
            tweenEase: "randomElementScale",
        });
        Tweens.alphaTween(this, {
            alphas: [this.minAlpha, this.maxAlpha],
            tweenDelay: delay,
            tweenDuration: duration,
            tweenEase: "randomElementAlpha",
            callbackFunction: this.tease,
            callbackParams: [steps, step + 1],
            callbackScope: this,
        });

        if (delay === 0) {
            PlayList.play("SND_FSWheelChoose");
        } else {
            Tweens.rotationTween(this, {
                degrees: [0, 0],
                tweenDuration: delay,
                callbackFunction: (): void => {
                    PlayList.play("SND_FSWheelChoose");
                },
            });
        }

        if (step === steps.length - 1) {
            const d = duration * 0.5;

            this.selectionTimer.start(d);
        }
    }

    //******************************************************************************************************************
    //  ON SELECTION TIMER
    //******************************************************************************************************************

    private onSelectionTimer(): void {
        this.selectionTimer.stop();

        PlayList.play("SND_FSSelect");

        let stoneIndex = 9 - this.selectionSymbols[this.selectionSymbols.length - 1];

        this.goToCase("SYMBOL_" + this.selectionSymbols[this.selectionSymbols.length - 1] + "_EXPAND");

        this.view.symbolSelectAlmostFinished();

        this.alpha = this.maxAlpha;
        Tweens.removeTweens(this, "all");
        Tweens.positionTween(this, {
            tweenX: [
                this.rectX + this.rectWidth * 0.5,
                this.goToX + this.goToXStep * (this.selectionSymbols.length - 1),
            ],
            tweenY: [this.rectY, this.goToY + this.goToYStep * stoneIndex],
            tweenDuration: this.goToDuration,
            tweenDelay: this.goToDelay,
            tweenEase: "quadOut",
            callbackFunction: (): void => {
                PlayList.play("SND_FSSelect");

                this.view.symbolSelectFinished();
            },
        });
        Tweens.scaleTween(this, {
            tweenValues: [new PIXI.Point(this.maxScale, this.maxScale), new PIXI.Point(this.goToScale, this.goToScale)],
            tweenDuration: this.goToDuration,
            tweenDelay: this.goToDelay,
            tweenEase: "quadOut",
        });
        Tweens.rotationTween(this, {
            degrees: [0, -2, 0],
            tweenDuration: 20,
        });
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/RandomElement.ts
 **/